export default "__VITE_ASSET__6fbe3d90__"